import {html} from 'lit-html';
import {repeat} from 'lit-html/directives/repeat';
import {unsafeHTML} from 'lit-html/directives/unsafe-html';
import {ifDefined} from 'lit-html/directives/if-defined';
import {live} from 'lit-html/directives/live';
import {classMap} from 'lit-html/directives/class-map';

import TemplateRegistry from '../template/template-registry';
import {ThemeCurrency} from '../const';
import {
    valueSync, optionValueText, optionValueClassMap, optionClassMap, optionName
} from '../template/template-util.js';

TemplateRegistry.templates['radio'] = (option, config, onChange) => html`
    ${repeat(option.values || [], (optionValue) => optionValue.value,(optionValue,index) => html`
        <label class="cl-po--radio-item ${classMap(optionValueClassMap(option, optionValue))}" >
            <input type="radio" class="cl-po--input ${classMap(optionClassMap(option))}" id="${option.id}-${index}" name="${optionName(option)}" .value=${optionValue.value} @change=${(e) => valueSync(e, option, onChange)}
                   .checked=${live(option.value == optionValue.value)} ?required=${option.required} ?disabled=${optionValue.disabled} form=${ifDefined(config.productFormLink)}>
            ${unsafeHTML(optionValueText(option, optionValue, ThemeCurrency.moneyFormat))}
        </label>
    `)}
`;